import {IOffer} from "./Offer";
import './OfferCard.css'
import OfferPriceView from "./OfferPriceView";
import OfferDetailsView from "./OfferDetailsView";

interface IOfferCardProps {
    offer: IOffer
    mobile: boolean
}

export default function OfferCard(props: IOfferCardProps) {
    if (props.mobile) {
        return <div className="Offer_card_container_mobile">
            <div className="Offer_card">
                <div className="Offer_card_title" style={{color: props.offer.color}}>
                    {props.offer.name}
                </div>
                <div className="Offer_card_line" style={{backgroundColor: props.offer.color}}/>
                {props.offer.price != null && <OfferPriceView price={props.offer.price}/>}
                {props.offer.price_string != null && <div className="Offer_card_price">{props.offer.price_string}</div>}
                <OfferDetailsView offer={props.offer}/>
            </div>
            <div className="Car_card_shadow"/>
        </div>
    } else {
        return <div className="Offer_card_container">
            <div className="Offer_card">
                <div className="Offer_card_title" style={{color: props.offer.color}}>
                    {props.offer.name}
                </div>
                <div className="Offer_card_line" style={{backgroundColor: props.offer.color}}/>
                {props.offer.price != null && <OfferPriceView price={props.offer.price}/>}
                {props.offer.price_string != null && <div className="Offer_card_price">{props.offer.price_string}</div>}
                <OfferDetailsView offer={props.offer}/>
            </div>
            <div className="Car_card_shadow"/>
        </div>
    }
}